import React, { useState } from 'react';
import { Select, Button, DatePicker, Checkbox, Tooltip, Icon } from 'antd';

import Grid from '@material-ui/core/Grid';
import { styles, useStyles } from './CommunicationProgramFormStyles';
import TextEvents from 'app/components/TextEvents';
import CommunicationProgramContainer from 'app/containers/CommunicationProgramContainer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommunicationProgram, clearCommunicationProgram } from 'app/actions/CommunicationProgramActions';
import { categoryAvailableClear } from 'app/actions/CategoryAvailableActions';
import ApiService from 'app/services/ApiService';
import { employeeById } from 'app/reducers';
import moment from 'moment';

const { Option } = Select;

const SelectItem = (name = [], value) => {
    let x = name[value]
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function CommunicationProgramForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    let [status, setStatus] = useState([]);
    let [subdirList, setSubdirList] = useState();
    let [contractList, setContractList] = useState();
    let [workList, setWorkList] = useState();
    const [id, setId] = useState([]);
    const [subdirec, setSubdirect] = useState([]);
    const [contract, setContract] = useState([]);
    const [work, setWork] = useState([]);
    const [name, setName] = useState([]);
    const [desc, setDesc] = useState([]);
    const [training, setTraining] = useState([]);
    const [initialCreationDate, setInitialCreationDate] = useState('');
    const [finalCreationDate, setFinalCreationDate] = useState('');
    const [initialRevDate, setInitialRevDate] = useState('');
    const [finalRevDate, setFinalRevDate] = useState('');
    const [notSuspended, setNotSuspended] = useState(false);
    const [collapse, setCollapse] = useState(true);
    const [contractFilterFake, setContractFilterFake] = useState([]);
    const [workFilterFake, setWorkFilterFake] = useState([]);
    const [courses, setCourses] = useState([]);

    const employeeData = useSelector(employeeById);

    const {
        siteId
    } = useSelector(state => state.Auth)



    const data = {
        CommunicationProgramFolio: id.toString(),
        CommunicationProgramName: name.length > 0 ? name[0].join("|") : "",
        CommunicationProgramDescription: desc,
        StatusName: status,
        idSubdirection: employeeData.idSubdirection,
        Contract: contract,
        Work: work,
        trainings: training.length > 0 ? training[0].join("|") : "",
        InitialCreationDate: initialCreationDate,
        FinalCreationDate: finalCreationDate,
        InitialRevDate: initialRevDate,
        FinalRevDate: finalRevDate,
        NotSuspended: notSuspended,
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize,
        IdCourse: courses.length > 0 ? courses.join("|") : "",
        idEmployee :employeeData.employeeId
    }

    const search = (params) => {


        dispatch(clearCommunicationProgram());
        dispatch(fetchCommunicationProgram(data));
        props.setFormData(data);
    }

  
    const newCommunicationProgram = () => {
        dispatch(categoryAvailableClear());
        props.setTab('2');
    }

    const disabledCStartDate = (current) => {
        if (finalCreationDate === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) > moment(finalCreationDate)) {
                return true;
            } else return false;
        }
    }
    const disabledCEndDate = (current) => {
        if (initialCreationDate === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) < moment(initialCreationDate)) {
                return true;
            } else return false;
        }
    }

    const disabledMStartDate = (current) => {
        if (finalRevDate === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) > moment(finalRevDate)) {
                return true;
            } else return false;
        }
    }
    const disabledMEndDate = (current) => {
        if (initialRevDate === "") {
            return false;
        } else {
            if (moment(current.format('YYYY-MM-DD')) < moment(initialRevDate)) {
                return true;
            } else return false;
        }
    }

    const toExport = async () => {
        await ApiService.getCommunicationProgramsExport(data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "ProgramadeComunicaciones.xlsx");
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const SelectSubdirItem = (name = [], value) => {
        setSubdirList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }

    const SelectContractItem = (name = [], value) => {
        setContractList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i} value={c}>{c}</Option>)
        );
    }

    const SelectWorkItem = (name = [], value) => {
        setWorkList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }
    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })

        if (i.length === 0) {
            switch (key) {
                case 'cpFolio':
                    setId([])
                    break;
                case 'subdirectionName':
                    setSubdirect([])
                    break;
                case 'contractName':
                    setContract([])
                    break;
                case 'workName':
                    setWork([])
                    break;
                case 'statusName':
                    setStatus([])
                    break;
                case 'communicationProgramName':
                    setName([])
                    break;
                case 'communicationProgramDescription':
                    setDesc([])
                    break;
                case 'training':
                    setTraining([])
                    break;
                case 'courses':
                    setCourses([])
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line array-callback-return
        i.map(() => {
            if (key === 'cpFolio') {
                setId([array]);
            } else if (key === 'subdirectionName') {
                let newsubdirList = [];
                array.map(i => {
                    // eslint-disable-next-line array-callback-return
                    return subdirList.map(ids => {
                        if (ids.subdirectionName === i) {
                            const res = ids['idSubdirection'];
                            newsubdirList.push(res);
                        }
                    })
                })
                setSubdirect([newsubdirList])
            } else if (key === 'contractName') {
                let newContractList = [];
                array.map(i => {
                    // eslint-disable-next-line array-callback-return
                    return contractList.map(ids => {
                        if (ids.contractName === i) {
                            const res = ids['idContract'];
                            newContractList.push(res);
                        }
                    })
                })
                setContract([newContractList])
                setContractFilterFake(array);
            }
            else if (key === 'workName') {
                let newWorkList = [];
                array.map(i => {
                    // eslint-disable-next-line array-callback-return
                    return workList.map(ids => {
                        if (ids.workName === i) {
                            const res = ids['idWork'];
                            newWorkList.push(res);
                        }
                    })
                })
                setWork([newWorkList])
                setWorkFilterFake(array);
            }
            else if (key === 'statusName') {
                setStatus([array])
            } else if (key === 'communicationProgramName') {
                setName([array])
            } else if (key === 'communicationProgramDescription') {
                setDesc([array])
            } else if (key === 'training') {
                setTraining([array])
            } else if (key === 'courses') {
                setCourses(value)

            }
        })
    }

    return (
        <div>
            <CommunicationProgramContainer>
                {(params) => {
                    return (
                        <div>
                            <div hidden={collapse}>
                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Folio'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona folio"
                                            onChange={(v, i) => handleChange(v, i, 'cpFolio')}
                                        >
                                            {SelectItem(params.communicationProgramFilter[0], 'folio')}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                        <TextEvents
                                            text='Nombre'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.inputSelect, paddingRight: 0 }}
                                            placeholder="Selecciona nombre"
                                            onChange={(v, i) => handleChange(v, i, 'communicationProgramName')}
                                        >
                                            {SelectItem(params.communicationProgramFilter[0], 'name')}
                                        </Select>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} direction="row">
                                    {/*<Grid item xs={6}>
                                    <TextEvents
                                        text='Subdirección'
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                    />
                                    <Select
                                        mode='multiple'
                                        showSearch
                                        optionFilterProp="children"
                                        style={styles.inputSelect}
                                        placeholder='Selecciona subdirección'
                                        onChange={(v, i) => handleChange(v, i, 'subdirectionName')}
                                    >
                                        {params.communicationProgramFilter[0] !== undefined ? SelectSubdirItem(params.communicationProgramFilter[0].subdirection, 'subdirectionName') : null}
                                    </Select>
                                </Grid>*/}
                                    <Grid item xs={6} >
                                        <TextEvents
                                            text='Tipo de capacitación'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona Capacitación"
                                            onChange={(v, i) => handleChange(v, i, 'training')}
                                        >
                                            {SelectItem(params.communicationProgramFilter[0], 'trainings')}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6} style={{ paddingLeft: 0, paddingRight: 0 }} >
                                        <TextEvents
                                            text='Estatus'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona estatus"
                                            onChange={(v, i) => handleChange(v, i, 'statusName')}
                                        >
                                            {SelectItem(params.communicationProgramFilter[0], 'statusName')}
                                        </Select>
                                    </Grid>
                                </Grid>
                                {params.communicationProgramFilter[0]?.contract.length > 0 ? (<Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Contrato'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            defaultValue={contractFilterFake}
                                            showSearch
                                            optionFilterProp="children"
                                            mode='multiple'
                                            style={styles.inputSelect}
                                            placeholder='Selecciona contrato'
                                            onChange={(v, i) => handleChange(v, i, 'contractName')}
                                        >
                                            {params.communicationProgramFilter[0] !== undefined ? SelectContractItem(params.communicationProgramFilter[0].contract, 'contractName') : null}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='OT'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            defaultValue={workFilterFake}
                                            mode='multiple'
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.inputSelect, paddingRight: 0 }}
                                            placeholder='Selecciona OT'
                                            onChange={(v, i) => handleChange(v, i, 'workName')}
                                        >
                                            {params.communicationProgramFilter[0] !== undefined ? SelectWorkItem(params.communicationProgramFilter[0].work, 'workName') : null}
                                        </Select>
                                    </Grid>
                                </Grid>) : null}

                                <Grid container spacing={2} direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Fecha de Creación'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Grid container spacing={2} direction="row">
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    disabledDate={disabledCStartDate}
                                                    placeholder='Selecciona Fecha Inicial'
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setInitialCreationDate(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    disabledDate={disabledCEndDate}
                                                    placeholder='Selecciona Fecha Final'
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setFinalCreationDate(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
                                        <TextEvents
                                            text='Fecha de Modificación'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Grid container spacing={2} direction="row">
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    disabledDate={disabledMStartDate}
                                                    placeholder='Selecciona Fecha Inicial'
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setInitialRevDate(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    disabledDate={disabledMEndDate}
                                                    placeholder='Selecciona Fecha Final'
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setFinalRevDate(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} direction="row">
                                    <Grid item xs={6} >
                                        <TextEvents
                                            text='Folio de Procedimiento'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Seleccionar nombre"
                                            onChange={(v, i) => handleChange(v, i, 'courses')}
                                            value={courses}
                                        >
                                            {/* {
                                            filtersListMedia.map((item) => (
                                                <Option key={item.idCourse}>{item.course}</Option>
                                            )) SelectItem(params.communicationProgramFilter[0], 'courses')
                                        } */
                                                params.communicationProgramFilter[0] !== undefined ? params.communicationProgramFilter[0].courses.map((item) => (
                                                    <Option key={item.idCourse}>{item.course}</Option>
                                                )) : ''
                                            }
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6} >
                                        <TextEvents
                                            text='.'
                                            color="white"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Checkbox onChange={(e) => setNotSuspended(e.target.checked)}>No considerar Suspendidos / Baja</Checkbox>
                                    </Grid>
                                </Grid>

                            </div>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                {
                                    collapse ?
                                        <Tooltip title={"Mostrar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(false)}
                                            >
                                                <Icon type="down" />
                                            </Button>
                                        </Tooltip> :
                                        <Tooltip title={"Ocultar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(true)}
                                            >
                                                <Icon type="up" />
                                            </Button>
                                        </Tooltip>
                                }
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={() => search(params)}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={toExport}
                                >
                                    Exportar
                                </Button>
                                {
                                    siteId === 'HUB' ?
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="primary"
                                            onClick={newCommunicationProgram}
                                        >
                                            Nuevo
                                        </Button> : null
                                }

                            </div>
                        </div>
                    )
                }}
            </CommunicationProgramContainer>
        </div>
    );

}